import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { LabelBadge } from "@/components/LabelBadge";

export default function AllArticles() {
  const { enc } = useParams();
  const [articles, setArticles] = useState([]);
  const isGhoulax = enc === "ghoulax";

  useEffect(() => {
    api.get("/articles", { params: { encyclopedia: enc } }).then((r) => setArticles(r.data)).catch(() => {});
  }, [enc]);

  const byCategory = {};
  articles.forEach((a) => (a.categories || ["Uncategorized"]).forEach((c) => {
    byCategory[c] = byCategory[c] || [];
    if (!byCategory[c].find((x) => x.slug === a.slug)) byCategory[c].push(a);
  }));

  return (
    <div className="mx-auto max-w-5xl px-4 py-10 sm:px-6">
      <p className="text-xs font-bold uppercase tracking-widest" style={{ color: isGhoulax ? "var(--ghoulax)" : "var(--zyfley)" }}>
        {isGhoulax ? "Ghoulax Archives" : "Zyfley Encyclopedia"}
      </p>
      <h1 className="mt-2 font-serif-arc text-3xl font-black sm:text-4xl">All Articles</h1>

      <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
        {articles.map((a) => (
          <Link key={a.slug} to={`/article/${a.slug}?enc=${enc}`} data-testid={`all-article-${a.slug}`} className="rounded-md border p-4 shadow-sm transition-shadow hover:shadow-md" style={{ backgroundColor: "var(--arc-card)" }}>
            <div className="flex items-center justify-between gap-2">
              <span className={`font-serif-arc font-bold ${isGhoulax ? "ghoulax-accent" : "zyfley-accent"}`}>{a.title}</span>
              {a.badge && <LabelBadge label={a.badge} />}
            </div>
            <p className="mt-1 line-clamp-2 text-sm" style={{ color: "var(--arc-text-2)" }}>{a.description}</p>
          </Link>
        ))}
      </div>
      {articles.length === 0 && <p className="mt-8 text-sm" style={{ color: "var(--arc-text-2)" }}>No articles yet.</p>}
    </div>
  );
}
